// extracted by mini-css-extract-plugin
export default {"card":"Card_card__2hcYj","card_header":"Card_card_header__Ss1sE","title":"Card_title__693qQ"};